import { render, staticRenderFns } from "./online_aftersale_list.vue?vue&type=template&id=21601ab4&scoped=true"
import script from "./online_aftersale_list.vue?vue&type=script&lang=js"
export * from "./online_aftersale_list.vue?vue&type=script&lang=js"
import style0 from "./online_aftersale_list.vue?vue&type=style&index=0&id=21601ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21601ab4",
  null
  
)

export default component.exports